import { useEffect, useMemo } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import makeStyles from '@mui/styles/makeStyles';
import { Grid, InputLabel, FormControl, Select, MenuItem, FormHelperText } from '@mui/material';
import { useUsersStore } from '@lib';
import { PermissionsUtils } from '@shared';
import { RoleType } from '@shared/types';
import { DelayedLinearProgress } from '@widgets';

const useStyles = makeStyles(() => ({
  fullWidth: {
    width: '100%',
  },
}));

export const StepSecurity = () => {
  const classes = useStyles();

  const { loading, users: managers, getUsers } = useUsersStore();

  const {
    control,
    formState: { errors },
    watch,
    setValue,
  } = useFormContext();
  const partnerAccountManagerId = watch('partnerAccountManagerId');

  useEffect(() => {
    getUsers();
  }, []);

  const manager = useMemo(() => managers.find((manager) => manager.id === partnerAccountManagerId), [managers, partnerAccountManagerId]);

  return (
    <Grid container>
      <DelayedLinearProgress className={classes.fullWidth} loading={loading} />
      {!loading && managers && (
        <Grid item xs={6}>
          <FormControl margin='normal' fullWidth error={!!errors.partnerAccountManagerName}>
            <InputLabel>Partner Account Manager *</InputLabel>
            <Controller
              name='partnerAccountManagerId'
              control={control}
              rules={{ required: 'Partner Account Manager is required' }}
              render={({ field: { onChange, ...field }, fieldState: { error } }) => (
                <>
                  <Select
                    {...field}
                    variant='standard'
                    fullWidth
                    readOnly={PermissionsUtils.hasRole(RoleType.ACCOUNT_MANAGER)}
                    onChange={(e) => {
                      onChange(e);
                      const manager = managers.find((manager) => manager.id === e.target.value);
                      setValue('partnerAccountManagerName', manager ? `${manager.firstname} ${manager.lastname}` : undefined);
                      setValue('ippGroup', undefined);
                    }}
                  >
                    {managers.map((item, idx) => (
                      <MenuItem key={idx} value={item.id}>
                        {`${item.firstname} ${item.lastname}`}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{error?.message}</FormHelperText>
                </>
              )}
            />
          </FormControl>
        </Grid>
      )}
      {!loading && managers && (
        <Grid item xs={6}>
          <FormControl margin='normal' fullWidth error={!!errors.ippGroup}>
            <InputLabel>Circle *</InputLabel>
            <Controller
              name='ippGroup'
              control={control}
              rules={{ required: 'Circle is required' }}
              render={({ field, fieldState: { error } }) => (
                <>
                  <Select {...field} variant='standard' fullWidth>
                    {manager &&
                      manager.circles.map((item, idx) => (
                        <MenuItem key={idx} value={item}>
                          {item}
                        </MenuItem>
                      ))}
                  </Select>
                  <FormHelperText>{error?.message}</FormHelperText>
                </>
              )}
            />
          </FormControl>
        </Grid>
      )}
    </Grid>
  );
};
